import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Router} from "@angular/router";
import {LoginService} from "../service/login.service";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";
import {User} from "../domain/user";

@Component({
    selector: 'bank-selector',
    template: require('./bankSelector.component.html')
})
export class BankSelectorComponent implements OnInit {

    @Input() modal:any;
    @Output() close = new EventEmitter();

    public error: any;
    public loading: boolean;
    private user: User;
    private loggedUserBankId: string;
    public selectedBank: Bank;
    public banks: Bank[];

    constructor(private router: Router,
                private loginService: LoginService, private bankService: BankService) {
        this.init();
    }

    public init(): void {
        this.getUser();
    }

    ngOnInit(): any {
    }

    private getUser(): void {
        this.loginService.getUserLoggedSubject().subscribe(
            (userLogged) => {
                this.user = userLogged;
                this.updateUserLogged();
                this.bankService.getBanksNoAuth().subscribe(
                    this.setBanks.bind(this),
                    () => {
                        this.bindError('Ocurrió un error al obtener los bancos.')
                    });
            },
            () => {
                //Do Nothing.
            });
    }

    private updateUserLogged(): void {
        if (this.user.rol && this.user.rol.client && this.user.bank && this.user.bank.id) {
            this.loggedUserBankId = this.user.bank.id.toString();
        }
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    public authenticateBank(): void {
        if (this.modal) {
            this.modal.hide();
        }
        if (this.selectedBank.id.toString() === this.loggedUserBankId && this.selectedBank.id.toString() != "") {
            this.router.navigate(['app/home/client']);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/login/bankSelector.component.ts
 **/